var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2D4692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4933 8.22206C13.4933 7.77319 13.3751 7.4205 13.1265 7.15556C12.8711 6.88331 12.5944 6.74381 12.2968 6.74381H9.9945V5.52262H13.2052C13.2052 5.52262 13.4679 5.427 13.4679 5.00006C13.4679 4.57369 13.2052 4.5 13.2052 4.5H4.76269C4.76269 4.5 4.5 4.57369 4.5 5.00063C4.5 5.427 4.76269 5.52262 4.76269 5.52262H8.01675V6.74325H5.71388C5.41688 6.74325 5.14012 6.88387 4.88419 7.15556C4.64231 7.4205 4.51744 7.77375 4.51744 8.22206L4.51069 11.9222C4.51069 11.9222 4.50394 12.6726 4.96687 13.077C5.36062 13.4229 5.95575 13.3639 5.95575 13.3639H6.903C7.01381 13.3639 7.23488 13.1873 7.23488 12.8858C7.23488 12.3778 6.84787 12.3266 6.84787 12.3266H6.03225C5.45062 12.3266 5.472 11.7602 5.472 11.7602V8.43581C5.472 7.99425 5.69306 7.77319 6.12169 7.77319H8.01675V13.7171C8.01675 13.7171 8.04431 14.0625 8.38294 14.0625H8.74913V7.77375H9.261V14.0625H9.62775C9.96637 14.0625 9.99394 13.7171 9.99394 13.7171V7.77319H11.889C12.3244 7.77319 12.5392 7.99425 12.5392 8.43525V11.7602C12.5392 11.7602 12.5595 12.3266 11.979 12.3266H11.1628C11.1628 12.3266 10.7758 12.3778 10.7758 12.8858C10.7758 13.1873 10.9969 13.3639 11.1077 13.3639H12.0549C12.0549 13.3639 12.6427 13.4229 13.0438 13.077C13.5067 12.672 13.5 11.9222 13.5 11.9222L13.4933 8.22206ZM9.26831 6.76519H8.74969V5.52206H9.26831V6.76519Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.23b893ac44fb1fd6d854934978681e96.svg";
export { ForwardRef as ReactComponent };